export default class EventService {
  private handlerMap: {
    [propName: string]: [(...args) => void, boolean, string][];
  };
  constructor() {
    this.handlerMap = {};
  }
  register(
    eventName: string,
    callback: (...args) => void,
    once = false,
    replaceMark = ""
  ) {
    if (!Reflect.has(this.handlerMap, eventName)) {
      this.handlerMap[eventName] = [];
    }
    if (replaceMark !== "") {
      const index = this.handlerMap[eventName].findIndex(
        (i) => i[2] === replaceMark
      );
      this.handlerMap[eventName].splice(
        index === -1 ? this.handlerMap[eventName].length : index,
        1,
        [callback, once, replaceMark]
      );
    } else {
      this.handlerMap[eventName].push([callback, once, replaceMark]);
    }
  }
  post(key: string, ...args) {
    if (!Reflect.has(this.handlerMap, key)) return;
    let handlers = this.handlerMap[key];
    if (handlers && handlers.length !== 0) {
      handlers = handlers.filter((item) => {
        const [fn, once] = item;
        Reflect.apply(fn, this, args);
        return !once;
      });
    }
    if (handlers.length !== this.handlerMap[key].length) {
      this.handlerMap[key] = handlers;
    }
  }
  unregister(key: string, handler?: (...args) => void) {
    if (!this.handlerMap[key]) {
      return;
    }
    if (!handler) {
      this.handlerMap[key].length = 0;
      return;
    }
    let handlers = this.handlerMap[key];
    if (handlers && handlers.length !== 0) {
      handlers = handlers.filter((item) => handler !== item[0]);
    }
    if (handlers.length !== this.handlerMap[key].length) {
      this.handlerMap[key] = handlers;
    }
  }
}
